import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5588288e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modal-main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Let's trigger this here modal!", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import modalChild from "../../components/ModalChild.vue"
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const childIsShowing = ref(false);
const bkClass = ref('bk');
const blurClass = ref('blur');

const toggleShow = () => {
  childIsShowing.value = !childIsShowing.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([childIsShowing.value ? blurClass.value : '', bkClass.value])
    }, [
      _hoisted_2,
      _createElementVNode("button", { onClick: toggleShow }, [
        (childIsShowing.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Hide child"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "Show child"))
      ])
    ], 2),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (childIsShowing.value)
          ? (_openBlock(), _createBlock(modalChild, {
              key: 0,
              onToggleShow: toggleShow
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})